import { TextField } from "@mui/material";

export default function SmallDateInput(props: any) {
  return (
    <TextField
      {...props}
      type="date"
      fullWidth
      InputLabelProps={{
        shrink: true, // para que la etiqueta no se solape
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          height: 38,
          borderRadius: "10px",
        },
        "& .MuiInputBase-input": {
          padding: "6px 12px",
          fontSize: "12px",
        },
        ...props.sx,
      }}
    />
  );
}
